export const RouteConstants = {
  ROUTE_HOME: "/home" as const,
  ROUTE_EPICTEST: "/epic-test" as const,

  /** CDI module (queries entry + tab shell) */
  ROUTE_CDI_MODULE: "/cdi" as const,
  ROUTE_DASHBOARD: "/dashboard" as const,
  ROUTE_MY_QUERIES: "/my-queries" as const,
  ROUTE_MESSAGES: "/messages" as const,
  ROUTE_MESSAGE_DETAILS: "/messages/:conversation_id" as const,
  ROUTE_QUERY_DETAILS: "/query-details/:query_id",
  ROUTE_CDI_ALERTS: "/cdi-alerts" as const,
  ROUTE_ENCOUNTER_DRG: "/encounter-drg" as const,

  /** Value Based Care (VBC) module */
  ROUTE_VBC_MODULE: "/vbc" as const,
  ROUTE_VBC_ALERTS: "/vbc/alerts" as const,

  /** Outpatient Clinical Documentation Integrity (OPCD) module */
  ROUTE_OPCD_MODULE: "/opcd" as const,
  ROUTE_OPCD_QUERIES: "/opcd/queries" as const,
  ROUTE_OPCD_HIM_ALERTS: "/opcd/him-alerts" as const,
  ROUTE_OPCD_CODING_ALERTS: "/opcd/coding-alerts" as const,
  ROUTE_OPCD_CODING_RESULTS: "/opcd/coding-results" as const,
  ROUTE_OPCD_QUERY_DETAILS: "/opcd/query-details/:query_id" as const,

  /** Utilization Management (UM / AURICLE) module */
  ROUTE_UM_MODULE: "/um" as const,
  ROUTE_UM_QUERIES: "/um/queries" as const,
  ROUTE_UM_REPORTS: "/um/reports" as const,
  ROUTE_UM_MY_QUERIES: "/um/my-queries" as const,
  ROUTE_UM_MESSAGES: "/um/messages" as const,
  ROUTE_UM_MESSAGE_DETAILS: "/um/messages/:conversation_id" as const,
  ROUTE_UM_ALERTS: "/um/alerts" as const,
  ROUTE_UM_QUERY_DETAILS: "/um/query-details/:query_id",

  /** CAiRE module */
  ROUTE_CAIRE_MODULE: "/caire" as const,
  ROUTE_CAIRE_PREDICTED_DC_DISPOSITION:
    "/caire/predicted-dc-disposition" as const,
  ROUTE_CAIRE_READMISSION_RISK: "/caire/readmission-risk" as const,
  ROUTE_CAIRE_DC_READINESS: "/caire/dc-readiness" as const,
  ROUTE_CAIRE_DC_BARRIERS: "/caire/dc-barriers" as const,

  ROUTE_UNAUTHORIZED: "/unauthorized" as const,

  /** Published Bulwark AI clinical care guidelines library */
  ROUTE_CLINICAL_CARE_GUIDELINES: "/clinical-care-guidelines" as const,

  /** Bulwark Encoder coding workbench */
  ROUTE_ENCODER: "/encoder" as const,
} as const;
